import { useEffect, useMemo } from 'react';

import { ALL_OPTION_KEY } from '@/common/constants';
import { API_URL } from '@/dtos';

import { useBaseReportTableQuery } from '../../queries';
import { ForfeitureReportTableParams } from '../ForfeitureReport.types';

export const QUERY_KEY = 'FORFEITURE_REPORT_QUERY';

const MIN_SEARCH_LEN = 3;
const useForfeitureReportQuery = (params: Partial<ForfeitureReportTableParams>) => {
  const currentSearch = useMemo(() => {
    if (!!params?.searchString && params?.searchString?.length >= MIN_SEARCH_LEN) {
      return params.searchString;
    }
    return null;
  }, [params.searchString]);

  const base = useBaseReportTableQuery(
    API_URL.REPORTS_FORFEITURE_REPORT_BREAKDOWN,
    [QUERY_KEY, currentSearch, params.employerId, params.forfeitureGroup, params?.planYearPeriod?.join(',')],
    {
      employer_id: params.employerId,
      show_ssn: true,
      forfeiture_report_group: params.forfeitureGroup,
      isSSNShowed: params.isSSNShowed,
      search_value: currentSearch,
      plan_year_period:
        params?.planYearPeriod && !params?.planYearPeriod.includes(ALL_OPTION_KEY)
          ? params?.planYearPeriod.join(',')
          : undefined,
    },
    {
      isPreviewMode: params.isPreviewMode,
    }
  );

  useEffect(() => {
    base.onChangePlanOptions([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params?.employerId]);

  useEffect(() => {
    base.setPage(0);
    base.setRawContentList([]);
    base.setRawHeaders([]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    params.employerId,
    params?.searchString,
    params.employerId,
    params?.forfeitureGroup,
    params?.planYearPeriod,
  ]);
  return base;
};

export default useForfeitureReportQuery;
